<template>
  <v-row class="mb-2">
    <v-col v-for="card in cards" :key="card.key" v-bind="colProps">
      <v-card class="pa-4" elevation="2" :disabled="!card.count" @click="card.onClick && card.onClick()">
        <div class="d-flex align-center">
          <v-icon :color="card.color" size="36" class="mr-4">{{ card.icon }}</v-icon>
          <div>
            <div class="text-h5 font-weight-bold">{{ card.count }}</div>
            <div class="text-body-2">{{ card.label }}</div>
          </div>
        </div>
        <!-- Only clickable (non-zero) cards show the action hint, so a muted card doesn't look tappable.
             A non-breaking space keeps every card the same height regardless. -->
        <div class="text-caption primary--text text-right mt-2">{{ card.count ? card.actionLabel : ' ' }}</div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  // Reusable "what needs attention" summary card row, shared by customer/company/admin dashboards.
  // Every card is always shown; a card with count 0 is muted/non-clickable via v-card's `disabled` prop.
  export default {
    name: 'SummaryCards',

    props: {
      // {key, icon, color, count, label, actionLabel, onClick}
      cards: {
        type: Array,
        required: true,
      },
      // Grid column props applied to each card's v-col, so callers can fit 3, 5 or 6 cards per row.
      colProps: {
        type: Object,
        default: () => ({cols: 12, sm: 4}),
      },
    },
  };
</script>
